import { useState, useEffect } from "react";
import { Navbar, Nav, Container } from "react-bootstrap";
import logo from '../assets/img/logo.svg';
import navIcon1 from '../assets/img/nav-icon1.svg';
import navIcon2 from '../assets/img/nav-icon2.svg';
import navIcon3 from '../assets/img/nav-icon3.svg';
import navIcon4 from '../assets/img/Logos.png';
import navIcon5 from '../assets/img/nav-icon4.svg'
import navIcon6 from '../assets/img/nav-icon5.svg'
import navIcon7 from '../assets/img/Huwai.svg';
import navIcon8 from '../assets/img/app-store-ios.svg';
import navIcon9 from '../assets/img/app2.svg';
import { HashLink  ,NavHashLink} from 'react-router-hash-link';


const Navbars = () => {
  
  // Play the sound.
  
  
  const [activeLink, setActiveLink] = useState('home');
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      if (window.scrollY > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    }

    window.addEventListener("scroll", onScroll);

    return () => window.removeEventListener("scroll", onScroll);
  }, [])

  const onUpdateActiveLink = (value) => {
    setActiveLink(value);
  }

  return (
   
    

    

    

      <Navbar expand="md" className={scrolled ? "scrolled" : ""}>
        <Container>
          <Navbar.Brand href="https://play.google.com">
            <img src={navIcon4} alt="Logo"  /> 
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav">
            <span className="navbar-toggler-icon"></span>
          </Navbar.Toggle>
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="ms-auto">
              <Nav.Link href="http://spiccatogames.com/" className={activeLink === 'home' ? 'active navbar-link' : 'navbar-link'} onClick={() => onUpdateActiveLink('home')}>Home</Nav.Link>
        
     
              
             
     

              

            </Nav>
            <span className="navbar-text">
              <div className="social-icon">

              <a href="https://play.google.com"><img src={navIcon5} alt="Icon" /></a>
              <a href="https://www.apple.com/tr/app-store/"><img src={navIcon9} alt="Icon" /></a>
              
              <a href="https://appgallery.huawei.com"><img src={navIcon7} alt="Icon" /></a>
              <a href="https://galaxystore.samsung.com/games"><img src={navIcon8} alt="Icon" /></a>
              <a href="http://www.spiccatogames.com/forum"><img src={navIcon6} alt="Icon" /></a>
              
              
              </div>
             
              <HashLink to='carier'>
                <button  className="vvd"><span>Let’s Connect</span></button>
              </HashLink>
              </span>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    
  )
} 
export default Navbars;